import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';
import { Link } from 'react-router';
import classnames from 'classnames';

const logoUrl = require('../styles/images/logo.png');

const messages = defineMessages({
  START: {
    id: 'Sidebar.START',
    defaultMessage: 'Übersicht Unternehmen',
  },
  COMPANY: {
    id: 'Sidebar.COMPANY',
    defaultMessage: 'Start',
  },
  CUSTOMER: {
    id: 'Sidebar.CUSTOMER',
    defaultMessage: 'Kunden',
  },
  TEAM: {
    id: 'Sidebar.TEAM',
    defaultMessage: 'Team Management',
  },
  ALL_USERS: {
    id: 'Sidebar.ALL_USERS',
    defaultMessage: 'Alle Benutzer',
  },
  SETTINGS: {
    id: 'Sidebar.SETTINGS',
    defaultMessage: 'Einstellungen',
  },
  BILLING: {
    id: 'Sidebar.BILLING',
    defaultMessage: 'Abrechnung',
  },
  COMPANY_ADMIN: { id: 'Sidebar.COMPANY_ADMIN', defaultMessage: 'Unternehmensadmin' },
  ADJUST_PROFILE: { id: 'Sidebar.ADJUST_PROFILE', defaultMessage: 'Unternehmenseinstellungen' },
  MANAGE_ACCOUNT: { id: 'Sidebar.MANAGE_ACCOUNT', defaultMessage: 'Nutzerkonto verwalten' },
  ITEMIZED_BILL: { id: 'Sidebar.ITEMIZED_BILL', defaultMessage: 'Einzelverbindungsnachweise' },
  SMS_TEMPLATE: { id: 'Sidebar.SMS_TEMPLATE', defaultMessage: 'SMS Vorlage' },
  EMAIL_TEMPLATE: { id: 'Sidebar.EMAIL_TEMPLATE', defaultMessage: 'E-Mail Vorlage' },
  ADMINISTRATION: { id: 'Sidebar.ADMINISTRATION', defaultMessage: 'Administration' },
  CREATE_COMPANY: { id: 'Sidebar.CREATE_COMPANY', defaultMessage: 'Unternehmen anlegen' },
  PRODUCTS: { id: 'Sidebar.PRODUCTS', defaultMessage: 'Produkte & Tarife' },
  DELETE_COMPANY: { id: 'Sidebar.DELETE_COMPANY', defaultMessage: 'Unternehmen löschen' }
});

function SidebarComponent({ config, isOpen, setIsOpen, intl: { formatMessage } }) {
  const {
    companyList,
    company,
    currentRouteName = '',
    hideSidebar,
    companyMembership
  } = config;

  const isGlobalAdmin = config.user && config.user.is_admin;
  const isCompanyAdmin = companyMembership && (companyMembership.is_owner || companyMembership.is_admin);
  const isAdmin = isGlobalAdmin || isCompanyAdmin;

  if (hideSidebar || !isAdmin) {
    return null;
  }

  return (
    <React.Fragment>
      {/* Mobile Overlay */}
      {isOpen && (
        <div 
          className="sidebar-overlay"
          onClick={() => setIsOpen(false)}
          style={{ display: 'none' }}
        />
      )}
      
      <div className={`sidebar-container ${isOpen ? 'sidebar-open' : ''}`} style={{ 
        width: '280px', 
        backgroundColor: 'var(--panel-bg)', 
        borderRight: '1px solid var(--panel-border)',
        display: 'flex', 
        flexDirection: 'column',
        height: '100vh',
        flexShrink: 0,
        zIndex: 1040
      }}>
      
      {/* Brand Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '0 20px', height: '56px', borderBottom: '1px solid var(--panel-border)', boxSizing: 'border-box' }}>

        <h2 style={{ fontSize: '18px', fontWeight: '700', margin: '0', color: 'var(--text-color)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', letterSpacing: '-0.5px' }}>
          tele-LOOK
        </h2>
      </div>

      {/* Main Navigation */}
      <div style={{ flex: 1, padding: '12px 16px', display: 'flex', flexDirection: 'column', gap: '4px', overflowY: 'auto' }}>
        
        {/* If a company is selected, show its internal links */}
        {company && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <Link
              to={`/company/${company.id}/`}
              className={currentRouteName === 'customer-list' ? '' : 'nav-item-hover'}
              style={{
                display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', textDecoration: 'none',
                backgroundColor: currentRouteName === 'customer-list' ? 'rgba(59, 130, 246, 0.1)' : 'transparent',
                color: currentRouteName === 'customer-list' ? 'var(--primary-color, #3b82f6)' : 'var(--text-color)',
                fontWeight: currentRouteName === 'customer-list' ? '600' : '500', transition: 'all 0.15s ease-in-out', fontSize: '14px'
              }}
            >
              <i aria-hidden="true" className="fa fa-folder-o" style={{ width: '20px', textAlign: 'center', fontSize: '16px', color: currentRouteName === 'customer-list' ? 'var(--primary-color, #3b82f6)' : 'var(--text-muted)' }} />
              {formatMessage(messages.CUSTOMER)}
            </Link>
          </div>
        )}

        {/* Company Admin Section */}
        {(company && isAdmin) && (
          <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <div style={{ fontSize: '11px', fontWeight: '600', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px', paddingLeft: '12px' }}>
              {formatMessage(messages.COMPANY_ADMIN)}
            </div>

            <Link 
              to={`/company/${company.id}/settings/`} 
              className={window.location.pathname.includes('/settings/') ? '' : 'nav-item-hover'}
              style={{ 
                display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', textDecoration: 'none', 
                backgroundColor: window.location.pathname.includes('/settings/') ? 'rgba(59, 130, 246, 0.1)' : 'transparent',
                color: window.location.pathname.includes('/settings/') ? 'var(--primary-color, #3b82f6)' : 'var(--text-color)',
                fontWeight: window.location.pathname.includes('/settings/') ? '600' : '500', transition: 'all 0.15s ease-in-out', fontSize: '14px' 
              }}
            >
              <i aria-hidden="true" className="fa fa-cog" style={{ width: '20px', textAlign: 'center', fontSize: '16px', color: window.location.pathname.includes('/settings/') ? 'var(--primary-color, #3b82f6)' : 'var(--text-muted)' }} />
              {formatMessage(messages.ADJUST_PROFILE)}
            </Link>

            <Link 
              to={`/company/${company.id}/user/`} 
              className={window.location.pathname.includes('/user/') ? '' : 'nav-item-hover'}
              style={{ 
                display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', textDecoration: 'none', 
                backgroundColor: window.location.pathname.includes('/user/') ? 'rgba(59, 130, 246, 0.1)' : 'transparent',
                color: window.location.pathname.includes('/user/') ? 'var(--primary-color, #3b82f6)' : 'var(--text-color)',
                fontWeight: window.location.pathname.includes('/user/') ? '600' : '500', transition: 'all 0.15s ease-in-out', fontSize: '14px' 
              }}
            >
              <i aria-hidden="true" className="fa fa-users" style={{ width: '20px', textAlign: 'center', fontSize: '16px', color: window.location.pathname.includes('/user/') ? 'var(--primary-color, #3b82f6)' : 'var(--text-muted)' }} />
              {formatMessage(messages.TEAM)}
            </Link>

            {(companyMembership && companyMembership.is_owner || isGlobalAdmin) && (
              <Link 
                to={`/company/${company.id}/payment`} 
                className={window.location.pathname.includes('/payment') ? '' : 'nav-item-hover'}
                style={{ 
                  display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', textDecoration: 'none', 
                  backgroundColor: window.location.pathname.includes('/payment') ? 'rgba(59, 130, 246, 0.1)' : 'transparent',
                  color: window.location.pathname.includes('/payment') ? 'var(--primary-color, #3b82f6)' : 'var(--text-color)',
                  fontWeight: window.location.pathname.includes('/payment') ? '600' : '500', transition: 'all 0.15s ease-in-out', fontSize: '14px' 
                }}
              >
                <i aria-hidden="true" className="fa fa-credit-card" style={{ width: '20px', textAlign: 'center', fontSize: '16px', color: window.location.pathname.includes('/payment') ? 'var(--primary-color, #3b82f6)' : 'var(--text-muted)' }} />
                {formatMessage(messages.MANAGE_ACCOUNT)}
              </Link>
            )}

            <Link 
              to={`/company/${company.id}/billing`} 
              className={window.location.pathname.includes('/billing') ? '' : 'nav-item-hover'}
              style={{ 
                display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', textDecoration: 'none', 
                backgroundColor: window.location.pathname.includes('/billing') ? 'rgba(59, 130, 246, 0.1)' : 'transparent',
                color: window.location.pathname.includes('/billing') ? 'var(--primary-color, #3b82f6)' : 'var(--text-color)',
                fontWeight: window.location.pathname.includes('/billing') ? '600' : '500', transition: 'all 0.15s ease-in-out', fontSize: '14px' 
              }}
            >
              <i aria-hidden="true" className="fa fa-file-text-o" style={{ width: '20px', textAlign: 'center', fontSize: '16px', color: window.location.pathname.includes('/billing') ? 'var(--primary-color, #3b82f6)' : 'var(--text-muted)' }} />
              {formatMessage(messages.ITEMIZED_BILL)}
            </Link>

            <Link 
              to={`/company/${company.id}/customize/sms`} 
              className={window.location.pathname.includes('/customize/sms') ? '' : 'nav-item-hover'}
              style={{ 
                display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', textDecoration: 'none', 
                backgroundColor: window.location.pathname.includes('/customize/sms') ? 'rgba(59, 130, 246, 0.1)' : 'transparent',
                color: window.location.pathname.includes('/customize/sms') ? 'var(--primary-color, #3b82f6)' : 'var(--text-color)',
                fontWeight: window.location.pathname.includes('/customize/sms') ? '600' : '500', transition: 'all 0.15s ease-in-out', fontSize: '14px' 
              }}
            >
              <i aria-hidden="true" className="fa fa-comment-o" style={{ width: '20px', textAlign: 'center', fontSize: '16px', color: window.location.pathname.includes('/customize/sms') ? 'var(--primary-color, #3b82f6)' : 'var(--text-muted)' }} />
              {formatMessage(messages.SMS_TEMPLATE)}
            </Link>

            <Link 
              to={`/company/${company.id}/customize/mail`} 
              className={window.location.pathname.includes('/customize/mail') ? '' : 'nav-item-hover'}
              style={{ 
                display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', textDecoration: 'none', 
                backgroundColor: window.location.pathname.includes('/customize/mail') ? 'rgba(59, 130, 246, 0.1)' : 'transparent',
                color: window.location.pathname.includes('/customize/mail') ? 'var(--primary-color, #3b82f6)' : 'var(--text-color)',
                fontWeight: window.location.pathname.includes('/customize/mail') ? '600' : '500', transition: 'all 0.15s ease-in-out', fontSize: '14px' 
              }}
            >
              <i aria-hidden="true" className="fa fa-envelope-o" style={{ width: '20px', textAlign: 'center', fontSize: '16px', color: window.location.pathname.includes('/customize/mail') ? 'var(--primary-color, #3b82f6)' : 'var(--text-muted)' }} />
              {formatMessage(messages.EMAIL_TEMPLATE)}
            </Link>

          </div>
        )}

        {/* Admin Actions */}
        {isGlobalAdmin && (
          <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <div style={{ fontSize: '11px', fontWeight: '600', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px', paddingLeft: '12px' }}>
              {formatMessage(messages.ADMINISTRATION)}
            </div>

            <Link 
              to="/company/" 
              className={window.location.pathname === '/company/' ? '' : 'nav-item-hover'}
              style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', textDecoration: 'none', backgroundColor: window.location.pathname === '/company/' ? 'rgba(59, 130, 246, 0.1)' : 'transparent', color: window.location.pathname === '/company/' ? 'var(--primary-color, #3b82f6)' : 'var(--text-color)', fontWeight: window.location.pathname === '/company/' ? '600' : '500', transition: 'all 0.15s ease-in-out', fontSize: '14px' }}
            >
              <i aria-hidden="true" className="fa fa-home" style={{ width: '20px', textAlign: 'center', fontSize: '16px', color: window.location.pathname === '/company/' ? 'var(--primary-color, #3b82f6)' : 'var(--text-muted)' }} />
              {formatMessage(messages.START)}
            </Link>

            <Link 
              to="/company/create/" 
              className={currentRouteName === 'company-create' ? '' : 'nav-item-hover'}
              style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', textDecoration: 'none', backgroundColor: currentRouteName === 'company-create' ? 'rgba(59, 130, 246, 0.1)' : 'transparent', color: currentRouteName === 'company-create' ? 'var(--primary-color, #3b82f6)' : 'var(--text-color)', fontWeight: currentRouteName === 'company-create' ? '600' : '500', transition: 'all 0.15s ease-in-out', fontSize: '14px' }}
            >
              <i aria-hidden="true" className="fa fa-plus" style={{ width: '20px', textAlign: 'center', fontSize: '16px', color: window.location.pathname === '/company/create/' ? 'var(--primary-color, #3b82f6)' : 'var(--text-muted)' }} />
              {formatMessage(messages.CREATE_COMPANY)}
            </Link>

            <Link 
              to="/users/" 
              className={window.location.pathname.includes('/users') ? '' : 'nav-item-hover'}
              style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', textDecoration: 'none', backgroundColor: window.location.pathname.includes('/users') ? 'rgba(59, 130, 246, 0.1)' : 'transparent', color: window.location.pathname.includes('/users') ? 'var(--primary-color, #3b82f6)' : 'var(--text-color)', fontWeight: window.location.pathname.includes('/users') ? '600' : '500', transition: 'all 0.15s ease-in-out', fontSize: '14px' }}
            >
              <i aria-hidden="true" className="fa fa-users" style={{ width: '20px', textAlign: 'center', fontSize: '16px', color: window.location.pathname.includes('/users') ? 'var(--primary-color, #3b82f6)' : 'var(--text-muted)' }} />
              {formatMessage(messages.ALL_USERS)}
            </Link>

            <Link 
              to="/products/" 
              className={window.location.pathname.includes('/products') ? '' : 'nav-item-hover'}
              style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', textDecoration: 'none', backgroundColor: window.location.pathname.includes('/products') ? 'rgba(59, 130, 246, 0.1)' : 'transparent', color: window.location.pathname.includes('/products') ? 'var(--primary-color, #3b82f6)' : 'var(--text-color)', fontWeight: window.location.pathname.includes('/products') ? '600' : '500', transition: 'all 0.15s ease-in-out', fontSize: '14px' }}
            >
              <i aria-hidden="true" className="fa fa-cubes" style={{ width: '20px', textAlign: 'center', fontSize: '16px', color: window.location.pathname.includes('/products') ? 'var(--primary-color, #3b82f6)' : 'var(--text-muted)' }} />
              {formatMessage(messages.PRODUCTS)}
            </Link>

            {company && (
              <Link 
                to={`/company/${company.id}/settings/`} 
                className={currentRouteName === 'company-update' ? '' : 'nav-item-hover'}
                style={{ 
                  display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', textDecoration: 'none', 
                  backgroundColor: currentRouteName === 'company-update' ? 'rgba(59, 130, 246, 0.1)' : 'transparent',
                  color: currentRouteName === 'company-update' ? 'var(--primary-color, #3b82f6)' : 'var(--text-color)',
                  fontWeight: currentRouteName === 'company-update' ? '600' : '500', transition: 'all 0.15s ease-in-out', fontSize: '14px',
                  justifyContent: 'space-between'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <i aria-hidden="true" className="fa fa-building-o" style={{ width: '20px', textAlign: 'center', fontSize: '16px', color: currentRouteName === 'company-update' ? 'var(--primary-color, #3b82f6)' : 'var(--text-muted)' }} />
                  {formatMessage(messages.SETTINGS)}
                </div>
                <span style={{ fontSize: '10px', backgroundColor: '#f59e0b', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>BETA</span>
              </Link>
            )}

            {(company && (companyMembership && companyMembership.is_owner || isGlobalAdmin)) && (
              <Link 
                to={`/company/${company.id}/delete/`} 
                className={currentRouteName === 'company-delete' ? '' : 'nav-item-hover'}
                style={{ 
                  display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 12px', borderRadius: '8px', textDecoration: 'none', 
                  backgroundColor: currentRouteName === 'company-delete' ? 'rgba(59, 130, 246, 0.1)' : 'transparent',
                  color: currentRouteName === 'company-delete' ? 'var(--primary-color, #3b82f6)' : 'var(--text-color)',
                  fontWeight: currentRouteName === 'company-delete' ? '600' : '500', transition: 'all 0.15s ease-in-out', fontSize: '14px'
                }}
              >
                <i aria-hidden="true" className="fa fa-trash-o" style={{ width: '20px', textAlign: 'center', fontSize: '16px', color: currentRouteName === 'company-delete' ? 'var(--primary-color, #3b82f6)' : 'var(--text-muted)' }} />
                {formatMessage(messages.DELETE_COMPANY)}
              </Link>
            )}
          </div>
        )}

      </div>
      
      {/* Global Style for Hover Effects and Responsive Sidebar */}
      <style>{`
        .nav-item-hover:hover {
          background-color: var(--hover-bg, rgba(0,0,0,0.04)) !important;
          color: var(--text-color) !important;
        }
        .nav-item-hover:hover i {
          color: var(--text-color) !important;
        }

        .sidebar-container {
          transition: transform 0.3s ease-in-out;
        }

        @media (max-width: 992px) {
          .sidebar-container {
            position: fixed !important;
            left: 0;
            top: 0;
            transform: translateX(-100%);
          }
          .sidebar-container.sidebar-open {
            transform: translateX(0);
            box-shadow: 4px 0 24px rgba(0,0,0,0.15);
          }
          .sidebar-overlay {
            display: block !important;
            position: fixed;
            top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(0,0,0,0.4);
            backdrop-filter: blur(4px);
            z-index: 1030;
          }
        }
      `}</style>
    </div>
    </React.Fragment>
  );
}

export default connect(
  state => ({ config: state.navbar }),
)(injectIntl(SidebarComponent));
